let captured: URLSearchParams | null = null;

try {
  if (typeof window !== "undefined" && window.location) {
    const path = window.location.pathname.replace(/\/+$/, "");
    const params = new URLSearchParams(window.location.search);
    if (path === "/connect-extension" && params.get("redirect_uri") && params.get("state")) {
      captured = params;
    }
  }
} catch {
  captured = null;
}

export function getCapturedExtensionConnect(): URLSearchParams | null {
  return captured;
}

export function isExtensionConnectFlow(): boolean {
  return captured !== null;
}
